import React from 'react';
import MegaMenu from '../MegaMenu/MegaMenu';
import clsx from 'clsx';

interface NavigationLinkProps {
  link: any;
  isActive: boolean;
  onLinkHover: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onMouseLeaveLink: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onMegaMenuClose: () => void;
  blocks: any[];
  right?: boolean;
}

const NavigationLink = ({
  link,
  isActive,
  onLinkHover,
  onMouseLeaveLink,
  onMegaMenuClose,
  blocks,
  right = false,
}: NavigationLinkProps) => {
  return (
    <>
      <a
        className={clsx(
          'text-white uppercase leading-6 cursor-pointer tracking-buttons text-sm font-satoshi-bold',
          isActive || link.isSelected
            ? 'p-3 bg-gray-700 underline decoration-primary-500 decoration-2 decoration-solid underline-offset-[6px]'
            : 'p-3'
        )}
        href={link.url}
        onClick={(e) => {
          if (link.links?.length > 0) {
            onLinkHover;
          }
        }}
        onMouseOver={onLinkHover}
        onMouseLeave={onMouseLeaveLink}
      >
        {link.name}
      </a>
      {link.links?.length > 0 && (
        <MegaMenu
          onMegaMenuClose={onMegaMenuClose}
          onMouseLeaveMegaMenu={onMouseLeaveLink}
          onMouseOverMegaMenu={() => onLinkHover(link)}
          link={link}
          open={isActive}
          blocks={blocks}
        />
      )}
    </>
  );
};

export default NavigationLink;
